<div class="flex flex-row justify-between">
  <p-breadcrumb
    [model]="[]"
    [home]="home"
  />
</div>
<div class="flex flex-row justify-between pb-2">
  <p-menubar
    class="w-full"
    [model]="this.menuItems"
  />
</div>

<p-table
  [value]="users"
  showGridlines
  (onEditComplete)="updateUser($event)"
  scrollHeight="calc(100svh - 106px - 1.5rem)"
>
  <ng-template #header>
    <tr>
      <th class="w-[50%]">Email</th>
      <th class="w-[50%]">Name</th>
      <th class="w-px">Erstellt am</th>
      <th class="w-px">Aktiviert</th>
      <th class="w-px"></th>
    </tr>
  </ng-template>
  <ng-template
    #body
    let-user
    let-editing="editing"
    let-ri="rowIndex"
  >
    <tr [ngStyle]="{'color': user.active ? '#000' : '#aaa'}">
      <td
        [pEditableColumn]="user.email"
        [pEditableColumnRowIndex]="ri"
        pEditableColumnField="email"
      >
        <p-cellEditor>
          <ng-template #input>
            <input
              pInputText
              [(ngModel)]="user.email"
              required
              fluid
              email
            />
          </ng-template>
          <ng-template #output>
            {{ user.email }}
          </ng-template>
        </p-cellEditor>
      </td>
      <td
        [pEditableColumn]="user.name"
        [pEditableColumnRowIndex]="ri"
        pEditableColumnField="name"
      >
        <p-cellEditor>
          <ng-template #input>
            <input
              pInputText
              [(ngModel)]="user.name"
              required
              fluid
            />
          </ng-template>
          <ng-template #output>
            {{ user.name }}
          </ng-template>
        </p-cellEditor>
      </td>
      <td>{{ user.createdAt | date: "dd.MM.yyyy&nbsp;HH:mm:ss"}}</td>
      <td>
        <div class="flex justify-center">
          @if(user.active){
          <i
            class="pi pi-circle-on cursor-pointer"
            style="color: var(--p-green-500)"
            (click)="toggleUserActive(user)"
          ></i>
          } @else {
          <i
            class="pi pi-circle-on cursor-pointer"
            style="color: var(--p-red-500)"
            (click)="toggleUserActive(user)"
          ></i>
          }
        </div>
      </td>
      <td #deleteCell>
        <div class="flex justify-center">
          <i
            class="pi pi-trash cursor-pointer"
            pTooltip="Löschen"
            tooltipPosition="top"
            style="color: var(--p-red-500)"
            (click)="confirmDelete($event, user)"
          ></i>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-confirmdialog />

<p-dialog
  header="Neuen Nutzer erstellen"
  [modal]="true"
  [(visible)]="this.newUserFormVisible"
  position="top"
  [draggable]="false"
  [style]="{ width: '25rem' }"
>
  <form
    [ngClass]="{'hidden': !this.newUserFormVisible }"
    [formGroup]="newUserForm"
    (ngSubmit)="createUser(); this.newUserFormVisible = false"
  >
    <div class="mt-3">
      <p-floatlabel variant="on">
        <input
          pInputText
          type="email"
          id="email"
          formControlName="email"
          [invalid]="isInvalid('email')"
          fluid
        />
        <label for="email">Email</label>
      </p-floatlabel>
      @if (isInvalid('email')) {
      @if (newUserForm.get('email')?.errors?.['required']) {
      <p-message
        severity="error"
        size="small"
        variant="simple"
      >Email ist ein Pflichtfeld.</p-message>
      }
      @if (newUserForm.get('email')?.errors?.['email']) {
      <p-message
        severity="error"
        size="small"
        variant="simple"
      >Email Adresse ist ungültig.</p-message>
      }
      }
    </div>
    <div class="mt-3">
      <p-floatlabel variant="on">
        <input
          pInputText
          type="text"
          id="name"
          formControlName="name"
          [invalid]="isInvalid('name')"
          fluid
        />
        <label for="Name">Name</label>
      </p-floatlabel>
      @if (isInvalid('name')) {
      <p-message
        severity="error"
        size="small"
        variant="simple"
      >Name ist ein Pflichtfeld.</p-message>
      }
    </div>
    <div class="flex justify-end gap-2 mt-3">
      <p-button
        severity="secondary"
        (click)="this.newUserFormVisible = false"
        label="Abbrechen"
      />
      <p-button
        type="submit"
        label="Anlegen"
      />
    </div>
  </form>
</p-dialog>